module.exports = __webpack_public_path__ + "static/media/certificado.2d217c4a.svg";